import { Component } from '@angular/core';

@Component({
  selector: 'app-contributor-component',
  templateUrl: './app-contributor.component.html',
  standalone: false,
})
export class AppContributorComponent {}
